import "regenerator-runtime";
import Vue from 'vue'
import App from './App.vue'
import VueResource from 'vue-resource';
import BootstrapVue from 'bootstrap-vue';
import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default-dark.css'
import 'vue-material/dist/theme/default.css'
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import {
  FontAwesomeIcon,
  FontAwesomeLayers,
  FontAwesomeLayersText,
} from '@fortawesome/vue-fontawesome';
import { io } from "socket.io-client";
import moment from 'vue-moment';
import { createProvider } from './vue-apollo';
import { getCookieValue } from './utils';
import lodash from 'lodash'
import VueClipboard from 'vue-clipboard2';

Vue.config.productionTip = false

Vue.use(BootstrapVue);
Vue.use(VueMaterial);

library.add(fas);
library.add(fab);
library.add(far);
Vue.component('fa-icon', FontAwesomeIcon);
Vue.component('fa-layers', FontAwesomeLayers);
Vue.component('fa-layers-text', FontAwesomeLayersText);

Vue.use(VueClipboard);

//needed to load the .env file
require('dotenv').config();

import $ from 'jquery';
window.$ = $;

import router from './routes';
import store from './store';

Vue.use(VueResource);
Vue.http.options.credentials = 'include';
Vue.http.interceptors.push((request) => {

  //for authorizating the http calls
  const token = getCookieValue('access_token')
  request.headers.set('Authorization', `Bearer ${token}`)
  request.headers.set('Accept', 'application/json')

  // return response callback
  return function(response) {
    if (response.status === 401) {
      if (router.currentRoute.meta.requiresAuth) router.push({name: 'LogIn'})
    }
  };
})

// Websocket initialization
export const socket = io(process.env.VUE_APP_WEBSOCKET_URL, {
  withCredentials: true,
});

socket.on('connect', () => {
  console.log("WEBSOCKET STARTED", socket.id)
})

socket.on('disconnect', () => {
  console.log("WEBSOCKET DISCONNECTED")
  // reconnecting
  socket.connect()
})

Vue.use(moment);

Vue.filter('date', value => {
  const vf = Vue.filter('moment');
  return vf(value, 'DD/MMM/YYYY');
});

Vue.filter('datetime', value => {
  const vf = Vue.filter('moment');
  return vf(value, 'DD/MMM/YYYY h:mm a');
});

Vue.filter('since', value => {
  const vf = Vue.filter('moment');
  return vf(value, 'from');
});

Vue.filter('monthYear', value => {
  const vf = Vue.filter('moment');
  return vf(value, 'MMMM YYYY');
});

Vue.filter('year', value => {
  const vf = Vue.filter('moment');
  return vf(value, 'YYYY');
});

Vue.filter('round2Decimals', value => {
  return Math.round((value + Number.EPSILON) * 100) / 100
});

Vue.filter('round6Decimals', value => {
  return value.toFixed(6)
});

Vue.filter('size', value => {
  if (value === 128) return 'XS'
  if (value === 256) return 'S'
  if (value === 512) return 'M'
  if (value === 1024) return 'L'
  if (value === 2048) return 'XL'
  if (value === 4096) return 'XXL'
  if (value === 8192) return 'XXXL'
});

Vue.filter('month', value => {
  if (value === 1) return 'January'
  if (value === 2) return 'February'
  if (value === 3) return 'March'
  if (value === 4) return 'April'
  if (value === 5) return 'May'
  if (value === 6) return 'June'
  if (value === 7) return 'July'
  if (value === 8) return 'August'
  if (value === 9) return 'September'
  if (value === 10) return 'October'
  if (value === 11) return 'November'
  if (value === 12) return 'December'
});

Vue.filter('status', value => {
  return value === 'succeeded' ? 'Succeeded' : value === 'failed' ? 'Failed' : 'In progress'
});

Vue.filter('cost2Decimals', value => {
  const price = value * 0.000023148148
  return Math.round((price + Number.EPSILON) * 100) / 100
});

Vue.filter('cost3Decimals', value => {
  const price = value * 0.000023148148
  return price.toFixed(3)
});

// make some objects globally available
Vue.mixin({
  data: function() {
    return {
      get lodash() {
        return lodash
      },
      get socket() {
        return socket;
      }
    }
  }
})

new Vue({
  render: h => h(App),
  store,
  router,
  apolloProvider: createProvider(),
}).$mount('#app')
